var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificationCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M11,24a4.665,4.665,0,0,1-4.888-4.391V19.2H2A2,2,0,0,1,.153,17.987a1.933,1.933,0,0,1,.433-2.138l2.2-2.164V8.071A8.011,8.011,0,0,1,5.6,2a8.293,8.293,0,0,1,5.414-2A8.4,8.4,0,0,1,12.1.07a8.277,8.277,0,0,1,7.114,8.254v5.36l2.2,2.164a1.928,1.928,0,0,1,.43,2.14A1.992,1.992,0,0,1,20,19.2H15.89v.408A4.666,4.666,0,0,1,11,24ZM8.556,19.2v.408A2.284,2.284,0,0,0,11,21.6a2.285,2.285,0,0,0,2.445-1.992V19.2ZM10.992,2.4A5.719,5.719,0,0,0,7.213,3.8a5.634,5.634,0,0,0-1.98,4.267v5.613a2.362,2.362,0,0,1-.716,1.7L3.074,16.8H18.928L17.485,15.38a2.36,2.36,0,0,1-.715-1.7V8.324A5.857,5.857,0,0,0,11.78,2.45,6.186,6.186,0,0,0,10.992,2.4Z",
    transform: "translate(0.001 -0.001)",
    fill: "#767493"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-icon",
    transform: "translate(-24 -152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 48,
    height: 48,
    transform: "translate(24 152)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_notification_center_Deactive",
    transform: "translate(37 164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M11,24a4.665,4.665,0,0,1-4.888-4.391V19.2H2A2,2,0,0,1,.153,17.987a1.933,1.933,0,0,1,.433-2.138l2.2-2.164V8.071A8.011,8.011,0,0,1,5.6,2a8.293,8.293,0,0,1,5.414-2A8.4,8.4,0,0,1,12.1.07a8.277,8.277,0,0,1,7.114,8.254v5.36l2.2,2.164a1.928,1.928,0,0,1,.43,2.14A1.992,1.992,0,0,1,20,19.2H15.89v.408A4.666,4.666,0,0,1,11,24ZM8.556,19.2v.408A2.284,2.284,0,0,0,11,21.6a2.285,2.285,0,0,0,2.445-1.992V19.2ZM10.992,2.4A5.719,5.719,0,0,0,7.213,3.8a5.634,5.634,0,0,0-1.98,4.267v5.613a2.362,2.362,0,0,1-.716,1.7L3.074,16.8H18.928L17.485,15.38a2.36,2.36,0,0,1-.715-1.7V8.324A5.857,5.857,0,0,0,11.78,2.45,6.186,6.186,0,0,0,10.992,2.4Z",
    transform: "translate(0)",
    fill: "#767493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationCenter);
export default __webpack_public_path__ + "static/media/icon_notification-center.1dce5060f371cccbd6e13a2a03cfdbb7.svg";
export { ForwardRef as ReactComponent };